<template>
  <div>
    <div class="smokeAlarmAuto">
      <div class="proOrder" style="text-align: center;margin-bottom:10px;">电动车报警调度派单</div>
      <div style="text-align: center;">
        <!-- <img src="~@/assets/img/smoke_f.png" alt />
        <img src="~@/assets/img/twoLight.png" alt style="margin:0 77px;" />
        <img src="~@/assets/img/smoke_h.png" alt /> -->
      </div>
      <div class="policeInfo">
        <div class="policeInfoTop">
          <img src="~@/assets/img/smoke_i.png" alt style="vertical-align: middle;" />
        </div>
        <div class="policeInfoBot">
          <div class="piBot">
            <img src="~@/assets/img/smokeIcon1.png" class="piTopImg" alt />
            <span class="piTopText">{{alarmInfo.alarmSingle.alarmTime}}</span>
            <img src="~@/assets/img/smokeIcon2.png" class="piTopImg" alt />
            <span class="piTopText">{{alarmInfo.alarmSingle.disasterAddress}}</span>
          </div>
        </div>
      </div>
      <div class="policeInfo">
        <div class="policeInfoTop">
          <img src="~@/assets/img/policePerson.png" alt style="vertical-align: middle;" />
        </div>
        <div class="policeInfoBot">
          <el-checkbox-group v-model="selectCjPersons">
            <el-row :gutter="32">
              <el-col :span="4" v-for="(item,index) in cjPersons" :key="index">
                <el-checkbox :label="item" :key="item.id">{{item.name}}</el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>
        <!-- <div class="policeOut" @click="police"><img src="~@/assets/img/policeOut.png" alt=""></div> -->
      </div>
      <div class="policeInfo">
        <div class="policeInfoTop">
          <img src="~@/assets/img/equiNum.png" alt style="vertical-align: middle;" />
        </div>
        <div class="policeInfoBot" v-if="selectEquip">
          <el-checkbox-group v-model="selectEqus">
            <el-row :gutter="32" v-for="(item,index) in equs" :key="index">
              <el-col :span="2">
                <el-checkbox :label="item" :key="item.id">{{item.ename}}</el-checkbox>
              </el-col>
              <el-col :span="6">
                <el-input-number
                  v-model="item.num"
                  :step="1"
                  size="small"
                  :min="0"
                  style="margin-left:5px;"
                ></el-input-number>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>
      </div>
      <div class="policeOut" @click="police" style="text-align:center;">
        <img src="~@/assets/img/policeOut.png" alt />
      </div>
    </div>
    <el-dialog
        :visible.sync="fireDocuDialog"
        width="939px"
        ::show-close="false"
        class="endNoticeDialog"
        append-to-body>
          <fireProbe ref="fireProbe" :alarmId ="alarmId" @closeFireProbe = "closeFireProbe"></fireProbe>
    </el-dialog>
  </div>
</template>

<script>
import fireProbe from '@/pages/fireBook/fireProbe'
export default {
  props: ['alarmId','subRep'],
  components:{
    fireProbe
  },
  data() {
    return {
      alarmInfo: {},
      selectCjPersons: [],
      cjPersons: [],
      selectEqus: [],
      equs: [],
      selectEquip:true,
      fireDocuDialog:false,
      selectRow: {id:this.alarmId},
    };
  },
  created() {
    let _this = this;
    _this.init();
    _this.queryProbeInfo();
    _this.handleSearch();
  },
  methods: {
    init(){
     let _this=this;
     _this.selectEqus=[];
     _this.selectCjPersons=[];
    },
    queryProbeInfo() {
      let _this = this;
      let success = function (resp) {
        _this.alarmInfo = resp;
      };
      _this.http.get("/webapi/probe/findProbe/" + _this.alarmId,{},success);
    },
    handleSearch() {
      let _this = this;
      var success = function (resp) {
        _this.cjPersons = resp.userDOList;
        resp.equipment.forEach(function (item) {
          item.num = 0;
          _this.equs.push(item);
        });
      };
      _this.http.get(
        "/webapi/writ/isMisdeclaration/" +_this.alarmId,{},success);
    },
    police() {
      let _this = this;
      _this.dispatchOrder2();
      _this.$emit('happenClose');

    },
    dispatchOrder2() {
      let _this = this;
      if (_this.selectEquip && _this.selectCjPersons.length <= 0) {
        _this.$message.warning("请选择出警人员");
        return;
      }
      if (_this.selectEquip && _this.selectEqus.length <= 0) {
        _this.$message.warning("请选择装备");
        return;
      }
      _this.selectEqus.forEach(function (item) {
        if (item.num === 0) {
          _this.$message.warning("已选装备数量不能为0");

        }
      });
      var alarmCommanderIds = _this.selectCjPersons.map((item) => {
        return item.id;
      });
      var equipmentIds = _this.selectEqus.map((item) => {
        return item.id;
      });
      var equipmentNumbers = _this.selectEqus.map((item) => {
        return item.num;
      });
      var data = {
        id: _this.alarmId,
        alarmCommanderIds: alarmCommanderIds.join(),
        equipmentIds: equipmentIds.join(),
        equipmentNumbers: equipmentNumbers.join(),
      };
      var success = function (resp) {
        if (resp.code === "0") {
           _this.fireDocuDialog = true;
          // _this.$store.commit('updateSmokeAlarmActive',_this.active++);
          // _this.$store.commit('updateSelectFireBookActive','first');
        }
      };
      _this.http.post("/webapi/writ/goPoliceAdd", data,success);
    },
    closeFireProbe(){
      let _this = this;
      _this.fireDocuDialog = false;
    }
  },
};
</script>

<style lang="less" scoped>
.proOrder{
  color: #FFFFFF;
  line-height: 30px;
  text-shadow: 0px 2px 10px rgba(4, 0, 0, 0.7);
  font-size: 24px;
  font-weight: 800;
}
.smokeAlarmAuto{
    .policeInfo{
        width: 842px;
        margin:auto;
        margin-top:18px;
        border: 1px solid #ffffff00;
        border-radius: 10px;
        .policeInfoTop{
            text-align: center;
            height: 60px;
            line-height: 60px;
            border-bottom:1px solid rgba(255, 255, 255, 0);
            position: relative;
            .policeNum{
                text-align: right;
            }
            .policeText{
                text-align: left;
            }
            .police{
                height: 280px;
                overflow-y: scroll;
            }


        }
           .lineHei{
                line-height: 32px;
                font-size: 20px;
                color:#fff;
            }
        .policeInfoBot{
              padding:10px 0 10px 43px;
              .el-form-item{
                  margin:0;
              }
            .piBot{
                span{
                    line-height: 46px;
                }
                .piTopText{
                    margin:0 30px 0 0px;
                    color:#fff;
                    font-size: 18px;
                }
            }
            .piTopImg{
                vertical-align: middle;
            }
            .piBtn{
                width: 132px;
                height: 39px;
                border: 1px solid #FFFFFF;
                border-radius: 20px;
                 background: #3B3B3B;
                color:#fff;
                margin-bottom:6px;
                margin-right: 23px;
            }
            .el-input{
               width:156px;
                height:32px;
               border-radius: 10px;
            }
            .el-textarea__inner{
               border-radius: 10px;
            }
        }
    }
    .policeSub{
        text-align: center;
        margin-top:20px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/probeAlarmShow.vue